export default "__VITE_ASSET__50c94669__"